import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../../images/sendity_logo.svg';
import { Link } from 'react-router-dom';
import { revolupaySteps } from '../../../../staticData/staticData';
import useIsMobile from '../../../../hooks/mobile';
import './revStep.css';
function MealPackSteps({ activeStep }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <>
      {!isMobile ? (
        <div className="col-md-5 step_sec_left">
          <Link to="/profile" className="sendity_logo">
            <img src={Logo} alt="" />
          </Link>
          <ul>
            <>
              {revolupaySteps.map((step, index) => {
                let className = 'font-s';
                if (activeStep > index) className = 'font-s completed';
                if (activeStep === index) className = 'font-s active';

                return (
                  <li key={index} className={className}>
                    {step.name === '¡Hecho!' ? `😎 ${t(step.name)}` : t(step.name)}
                  </li>
                );
              })}
            </>
          </ul>
        </div>
      ) : null}
    </>
  );
}
export default MealPackSteps;
